import React, { useState } from 'react';
import { X } from 'lucide-react';
import { S3Modal } from './v3/primitives';
import type { MergeCandidate } from '../../services/supportApi';
// Le modali sono condivise con l'area rappresentante, che non passa dalla
// shell admin ne dalla pagina del Centro Ticket: i due fogli scoped (.adm2 /
// .sup3, entrambi portati da S3Modal sulla radice) vanno importati qui.
import '../../styles/admin-v2.css';
import '../../styles/support-v3.css';


interface MergeModalProps {
  candidates: MergeCandidate[];
  busy?: boolean;
  onClose: () => void;
  onMerge: (targetTicketId: string) => void | Promise<void>;
}

// Modal «Unisci a un altro ticket»: i messaggi confluiscono nel ticket scelto.
// Resa V3 (T11): l'avviso di irreversibilita resta in evidenza, in ambra.
const MergeModal: React.FC<MergeModalProps> = ({ candidates, busy = false, onClose, onMerge }) => {
  const [target, setTarget] = useState<string>('');

  return (
    <S3Modal open onClose={onClose} labelledBy="s3-merge-title">
      <div className="s3-mod">
        <div className="s3-mod__head">
          <h3 className="s3-h3" id="s3-merge-title">Unisci a un altro ticket</h3>
          <button
            type="button"
            className="s3-pill s3-pill--sm s3-pill--icon"
            onClick={onClose}
            aria-label="Chiudi"
          >
            <X size={14} />
          </button>
        </div>

        <div className="s3-mod__body">
          <p className="s3-mod__warn">
            I messaggi di questo ticket verranno copiati nel ticket scelto e questo verrà chiuso con un rimando. L'operazione non è annullabile.
          </p>
          {candidates.length === 0 ? (
            <p className="s3-mod__note">Nessun altro ticket aperto dello stesso associato nei tuoi canali.</p>
          ) : (
            <div className="s3-pick">
              {candidates.map((c) => (
                <label
                  key={c._id}
                  className={`s3-pick__opt${target === c._id ? ' s3-pick__opt--on' : ''}`}
                >
                  <input
                    type="radio"
                    name="mergeTarget"
                    checked={target === c._id}
                    onChange={() => setTarget(c._id)}
                  />
                  <span className="s3-pick__txt">
                    <span className="s3-pick__strong">#{c.ticketNumber}</span> — {c.subject}
                    <span className="s3-pick__sub">
                      {c.groupId?.nome} · {c.status}
                    </span>
                  </span>
                </label>
              ))}
            </div>
          )}
        </div>

        <div className="s3-mod__foot">
          <button type="button" className="s3-pill" onClick={onClose}>
            Annulla
          </button>
          <button
            type="button"
            className="s3-pill s3-pill--primary"
            onClick={() => target && onMerge(target)}
            disabled={!target || busy}
          >
            Unisci
          </button>
        </div>
      </div>
    </S3Modal>
  );
};

export default MergeModal;
